import { db } from '../config/firebase';
import { doc, getDoc } from 'firebase/firestore';

/**
 * Checks if the given uid belongs to an admin user by reading Firestore /admins/{uid}.
 * @param uid The user's UID
 * @returns Promise<boolean> true if admin, false otherwise
 */
export async function isAdminUser(uid: string): Promise<boolean> {
  if (!uid) return false;
  const ref = doc(db, 'admins', uid);
  const snap = await getDoc(ref);
  return snap.exists();
}
